import { render, staticRenderFns } from "./ReviewYourAnswersAPSP.vue?vue&type=template&id=08da60cb"
import script from "./ReviewYourAnswersAPSP.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersAPSP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports